import React from 'react';

import { Button } from '@thd-olt-component-react/button';

export const PromoGoToCart = () => (
  <Button
    outline
    dark
    tag="a"
    href="/mycart/home"
  >
    Go to Cart
  </Button>
);

PromoGoToCart.displayName = 'PromoGoToCart';